module.exports = __webpack_public_path__ + "img/giftbox-black.653064b.png";